'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.component("mktDashboardPage", {
  bindings: {},
  template: require("./mkt-dashboard-page.html"),
  controller: function controller(mktDashboardService, $dialogBox, arrayUtils, $session, $translate, mktCourbesTauxService) {
    var ctrl = this;
    mktCourbesTauxService.getCompteCourbeTauxCurrency($session).then(function (devise) {
      ctrl.state = {
        currency: devise,
        favEdition: false
      };
    });
    function refreshFavoriteList() {
      return mktDashboardService.getFavoriteIndexations().then(function (indexations) {
        ctrl.favoriteIndexations = indexations;
      });
    }
    ctrl.$onInit = function () {
      ctrl.detteIndexes = [];
      ctrl.favoriteIndexations = [];
      mktDashboardService.getDetteIndexes().then(function (indexes) {
        ctrl.detteIndexes = indexes;
      });
      refreshFavoriteList();
    };
    ctrl.createFavorite = function () {
      mktDashboardService.openFavoriteCreationPopin().then(function (favorite) {
        ctrl.favoriteIndexations.push(favorite);
      });
    };
    ctrl.toggleFavEdition = function () {
      ctrl.state.favEdition = !ctrl.state.favEdition;
    };
    ctrl.deleteFavorite = function (favoriteId) {
      $dialogBox.confirm({
        title: $translate("marche.dashboard.suppressionFavori.title"),
        text: $translate("marche.dashboard.suppressionFavori.text")
      }).then(function () {
        return mktDashboardService.deleteFavorite(favoriteId).then(function (success) {
          if (success) {
            var index = _.findIndex(ctrl.favoriteIndexations, {
              favoriteId: favoriteId
            });
            if (index > -1) {
              ctrl.favoriteIndexations.splice(index, 1);
            }
          }
        });
      });
    };
    ctrl.moveFavorite = function (favoriteId, toLeft) {
      var len = ctrl.favoriteIndexations.length;
      var index = _.findIndex(ctrl.favoriteIndexations, {
        favoriteId: favoriteId
      });
      if (toLeft && index === 0 || !toLeft && index === len - 1) {
        return;
      }
      var secondIndex = index + (toLeft ? -1 : 1);
      var secondId = ctrl.favoriteIndexations[secondIndex].favoriteId;
      mktDashboardService.switchFavoritePositions(favoriteId, secondId).then(function (success) {
        arrayUtils.swapElements(ctrl.favoriteIndexations, index, secondIndex);
      });
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/dashboard/mkt-dashboard-page.js
// module id = 2838
// module chunks = 13